export enum PortsTabs {
  Add = "1",
  Table = "2",
}
